
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAisTargetSleepingIec as ObiAisTargetSleepingIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ais-target-sleeping-iec.js';
 
 
 

 
 export const ObiAisTargetSleepingIec = createComponent({
   react: React,
   tagName: 'obi-ais-target-sleeping-iec',
   elementClass: ObiAisTargetSleepingIecElement,
   events: {
     
   }
  });
 
 